import SkeletonDashboard from './SkeletonDashboard'

export default SkeletonDashboard